import { Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { useEffect, useRef } from "react";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CTypography from "src/components/CTypography";
import FormikControl from "src/components/formik/FormikControl";
import { RoutePaths } from "src/constants";
import { ContainedButton, OutlinedButton } from "src/components/button-group";
import { AppDispatch } from "src/store";
import {
 IUserForm
} from "../type";
import { fetchLocations } from "src/slices/configuration/thunks";
import { selectLocations } from "src/slices/configuration/selectors";
import { createUser, fetchRoles, fetchUserById, updateUser } from "src/slices/users/thunk";
import { IRole, IUser } from "src/slices/users/type";
import { selectRoles, selectUserDetail } from "src/slices/users/selectors";

export function CreateUpdateUser() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const rolesOptions: IRole[] = useSelector(selectRoles)
  const location = useSelector(selectLocations);

  const { userId } = useParams();
  const userDetails = useSelector(selectUserDetail);

  const formikRef = useRef(null);

  // const {errors} = formikRef?.current
  // console.log(formikRef?.current?.errors)

  // Form Inital Values
  const formInitialValue: IUserForm = {
    userCode: "",
    firstName: "",
    lastName: "",
    gender: "",
    CNIC: "",
    CNICExpiryDate: "",
    dob: new Date(),
    religion: "",
    hireDate: new Date(),
    roleId: 0,
    isMarried: false,
    address: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    mobile: "",
    emailId: "",
    password: "",
    userId: "",
    location:[]
  };


  // Form Fields Validation
  const validationSchemaModel = Yup.object().shape({
    password: Yup.string().required('Password is required'),
    confirmPassword: Yup.string()
     .oneOf([Yup.ref('password'), null], 'Passwords must match')

    
  });

  // Click Events
  const onClickSubmit = async (values: IUserForm) => {
    const user:IUserForm = {
      // customerId: customerId ? customerId : null,
      userCode: values.userCode,
      firstName: values.firstName,
      lastName: values.lastName,
      gender: values.gender,
      CNIC: values.CNIC,
      CNICExpiryDate: values.CNICExpiryDate,
      religion: values.religion,
      roleId: values.roleId,
      isMarried: values.isMarried,
      dob: values.dob,
      hireDate: values.hireDate,
      mobile: values.mobile,
      state: values.state,
      address: values.address,
      city: values.city,
      country: values.country,
      postalCode: values.postalCode,
      emailId: values.emailId,
      password: values.password,
      location: values.location || []

    } ;

    if(userId){
      dispatch(updateUser({
        ...user,
        userId
      })).then((result: any) => {
        if (!result.payload.error) {
          navigate(RoutePaths.USER_LISTING);
        }
      });
    }
    else
      dispatch(createUser(user)).then((result: any) => {
        if (!result.payload.error) {
          navigate(RoutePaths.USER_LISTING);
        }
      });
  };

  // If Customer Update Screen
  useEffect(() => {
    if (userId) {
      dispatch(fetchUserById(userId));
    }
    dispatch(fetchRoles())
    // eslint-disable-next-line
  }, [userId]);



  useEffect(() => {
    // console.log('userDetails',userDetails)
    if (userId) {
      if (userDetails) {
        loadCustomerData(userDetails);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetails]);

  useEffect(() => {  
      dispatch(fetchLocations());
      // eslint-disable-next-line
    }, []);

  const loadCustomerData = async (USER: IUser) => {
    const { setFieldValue } = formikRef.current;

    setFieldValue("userCode", USER.userCode);
    setFieldValue("gender", USER.gender);
    setFieldValue("dob", new Date(USER.dob));
    setFieldValue("mobile", USER.mobile);
    setFieldValue("firstName", USER.firstName);
    setFieldValue("lastName", USER.lastName);
    setFieldValue("hireDate", USER.hireDate);
    setFieldValue("religion", USER.religion);
    setFieldValue("CNIC", USER.CNIC);
    setFieldValue("CNICExpiryDate", USER.CNICExpiryDate);
    setFieldValue("address", USER.address);
    setFieldValue("city", USER.city);
    setFieldValue("state", USER.state);
    setFieldValue("country", USER.country);
    setFieldValue("postalCode", USER.postalCode);
    setFieldValue("roleId", USER.roles[0]?.id);
    setFieldValue("emailId", USER.emailId);
    setFieldValue("location", USER.locations.map((loc) => loc.id));
    // setFieldValue("branchId", USER.branchId;
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Formik
          initialValues={formInitialValue}
          validationSchema={!userId && validationSchemaModel}
          innerRef={formikRef}
          onSubmit={(values) => {
            onClickSubmit(values);
          }}
        >
          {({ values, touched, errors, setFieldValue, getFieldProps }) => (
            <Form id="CreateOrder">
              {/* Personal Information */}
              <Grid container spacing={1} pb={3}>
                <Grid item xs={12}>
                  <CTypography fontWeight="bold">
                    Personal Information
                  </CTypography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="InputField"
                    required
                    name="userCode"
                    label={"User Code"}
                    error={Boolean(
                      touched.userCode && errors.userCode
                    )}
                    helperText={
                      touched.userCode && errors.userCode
                    }
                    {...getFieldProps("userCode")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="InputField"
                    required
                    name="firstName"
                    label={"User First Name"}
                    error={Boolean(
                      touched.firstName && errors.firstName
                    )}
                    helperText={
                      touched.firstName && errors.firstName
                    }
                    {...getFieldProps("firstName")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="InputField"
                    required
                    name="lastName"
                    label={"User Last Name"}
                    error={Boolean(
                      touched.lastName && errors.lastName
                    )}
                    helperText={
                      touched.lastName && errors.lastName
                    }
                    {...getFieldProps("lastName")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="SelectField"
                    required
                    name="gender"
                    label="Gender"
                    options={[
                      {
                        label: "Male",
                        value: "male",
                      },
                      {
                        label: "Female",
                        value: "female",
                      },
                    ]}
                    error={Boolean(touched.gender && errors.gender)}
                    helperText={touched.gender && errors.gender}
                    {...getFieldProps("gender")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="InputField"
                    required
                    name="CNIC"
                    label={"CNIC"}
                    error={Boolean(
                      touched.CNIC && errors.CNIC
                    )}
                    helperText={
                      touched.CNIC && errors.CNIC
                    }
                    {...getFieldProps("CNIC")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="CalendarTime"
                    label="CNIC Expiry Date"
                    dateOrTimeOnly="date"
                    name="CNICExpiryDate"
                    required
                    // disableFuture
                    error={Boolean(touched.CNICExpiryDate && errors.CNICExpiryDate)}
                    helperText={touched.CNICExpiryDate && errors.CNICExpiryDate}
                    {...getFieldProps("CNICExpiryDate")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="InputField"
                    required
                    name="religion"
                    label={"Religion"}
                    error={Boolean(
                      touched.religion && errors.religion
                    )}
                    helperText={
                      touched.religion && errors.religion
                    }
                    {...getFieldProps("religion")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="CalendarTime"
                    label="Date of Birth"
                    dateOrTimeOnly="date"
                    name="dob"
                    required
                    disableFuture
                    error={Boolean(touched.dob && errors.dob)}
                    helperText={touched.dob && errors.dob}
                    {...getFieldProps("dob")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="CalendarTime"
                    label="Hire Date"
                    dateOrTimeOnly="date"
                    name="hireDate"
                    required
                    disableFuture
                    error={Boolean(touched.hireDate && errors.hireDate)}
                    helperText={touched.hireDate && errors.hireDate}
                    {...getFieldProps("hireDate")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="SelectField"
                    name="roleId"
                    label="Role"
                    required
                    options={rolesOptions?.map(role => ({
                      label:role.name,
                      value:role.id
                    }))}
                    error={Boolean(touched.roleId && errors.roleId)}
                    helperText={touched.roleId && errors.roleId}
                    {...getFieldProps("roleId")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="SelectField"
                    name="isMarried"
                    label="Status"
                    required
                    options={[
                      {
                        label: "Married",
                        value: true,
                      },
                      {
                        label: "Single",
                        value: false,
                      },
                    ]}
                    error={Boolean(touched.isMarried && errors.isMarried)}
                    helperText={touched.isMarried && errors.isMarried}
                    {...getFieldProps("isMarried")}
                  />
                </Grid>
              </Grid>

              {/* Contact Information */}
              <Grid container spacing={1} pb={3}>
                <Grid item xs={12}>
                  <CTypography fontWeight="bold">
                    Contact Information
                  </CTypography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormikControl
                    control="InputField"
                    required
                    name="mobile"
                    label="Contact Number"
                    error={Boolean(
                      touched.mobile && errors.mobile
                    )}
                    helperText={touched.mobile && errors.mobile}
                    {...getFieldProps("mobile")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={8}>
                  <FormikControl
                    control="InputField"
                    required
                    name="address"
                    label="Address"
                    error={Boolean(touched.address && errors.address)}
                    helperText={touched.address && errors.address}
                    {...getFieldProps("address")}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormikControl
                    control="InputField"
                    required
                    name="city"
                    label="City"
                    error={Boolean(touched.city && errors.city)}
                    helperText={touched.city && errors.city}
                    {...getFieldProps("city")}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormikControl
                    control="InputField"
                    required
                    name="state"
                    label="State"
                    error={Boolean(touched.state && errors.state)}
                    helperText={touched.state && errors.state}
                    {...getFieldProps("state")}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormikControl
                    control="InputField"
                    name="postalCode"
                    required
                    label="Postal Code"
                    error={Boolean(touched.postalCode && errors.postalCode)}
                    helperText={touched.postalCode && errors.postalCode}
                    {...getFieldProps("postalCode")}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormikControl
                    control="InputField"
                    required
                    name="country"
                    label="Country"
                    error={Boolean(touched.country && errors.country)}
                    helperText={touched.country && errors.country}
                    {...getFieldProps("country")}
                  />
                </Grid>
              </Grid>

              {/* Branch Imformation */}
                            <Grid container spacing={1} pb={3}>
                              <Grid item xs={12}>
                                <CTypography fontWeight="bold">
                                  Branch Information
                                </CTypography>
                              </Grid>
                              <Grid item xs={12} sm={6} md={4}>
                                <FormikControl
                                  control="SelectMultipleFields"
                                  name="location"
                                  label="Branch Name"
                                  defaultValue={values?.location?.map((loc) => loc)}
                                  options={location.map((service) => ({
                                    value: service.id,
                                    label: service.name,
                                  }))}
                                  handleChange={(value: any) => {
                                    setFieldValue("location", value);
                                  }}
                                  error={Boolean(touched.location && errors.location)}
                                  helperText={touched.location && errors.location}
                                  {...getFieldProps("location")}
                                />
                              </Grid>
                            </Grid>

              {/* LOGIN CREDS */}
              {
                !userId ? (
                  <Grid container spacing={1} pb={3}>
                    <Grid item xs={12}>
                      <CTypography fontWeight="bold">
                        LogIn Credentials
                      </CTypography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <FormikControl
                        control="InputField"
                        required
                        name="emailId"
                        label="Email"
                        error={Boolean(
                          touched.emailId && errors.emailId
                        )}
                        helperText={touched.emailId && errors.emailId}
                        {...getFieldProps("emailId")}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormikControl
                        control="InputField"
                        required
                        name="password"
                        label="password"
                        error={Boolean(touched.password && errors.password)}
                        helperText={touched.password && errors.password}
                        {...getFieldProps("password")}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormikControl
                        control="InputField"
                        name="confirmPassword"
                        label="Confirm Password"
                        required
                        error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                        helperText={touched.confirmPassword && errors.confirmPassword}
                        {...getFieldProps("confirmPassword")}
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container spacing={1} pb={3}>
                    <Grid item xs={12}>
                      <CTypography fontWeight="bold">
                        Update Password
                      </CTypography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormikControl
                        control="InputField"
                        name="password"
                        label="Password"
                        error={Boolean(touched.password && errors.password)}
                        helperText={touched.password && errors.password}
                        {...getFieldProps("password")}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormikControl
                        control="InputField"
                        name="confirmPassword"
                        label="Confirm Password"
                        error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                        helperText={touched.confirmPassword && errors.confirmPassword}
                        {...getFieldProps("confirmPassword")}
                      />
                    </Grid>
                  </Grid>
                )
              }

              {/* SUBMIT FORM */}
              <Grid container spacing={1}>
                <Grid item>
                  <ContainedButton type="submit">SUBMIT</ContainedButton>
                </Grid>
                <Grid item>
                  <OutlinedButton
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    CANCEL
                  </OutlinedButton>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Grid>
    </Grid>
  );
}
